import { RouterModule } from '@angular/router';
var contentLoggedoutRoutes = [
    {
        path: 'connexion',
        redirectTo: '/',
        pathMatch: 'full'
    }
];
export var contentLoggedoutRouting = RouterModule.forChild(contentLoggedoutRoutes);
//# sourceMappingURL=content-loggedout.routing.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/components/content-loggedout.routing.js
// module id = 1167
// module chunks = 0